import React from 'react';
import Button from '@material-ui/core/Button';

const ButtonSlim = (props) => {
  return <Button variant="text" color="primary" {...props} />;
};

export default ButtonSlim;
